import { PaymentLinkRedirectParams } from '@constants/paymentLink';
import { appendQueryParams } from '@utils/appendQueryParams';
import getUrlParam from '@utils/getUrlParam';

const handleRedirect = <T = Record<string, unknown>>(params?: T): boolean => {
  const redirectUrl = getUrlParam(PaymentLinkRedirectParams.REDIRECT_URL);

  if (redirectUrl) {
    const url = appendQueryParams(redirectUrl, params);

    window.location.replace(url);
  }

  return !!redirectUrl;
};

export default handleRedirect;
